import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import CustomTabPanel from 'components/custom-tab-panel'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Page from 'components/page'
import Soon from 'components/soon'
import AllianzStore from 'components/svg/allianz-store'
import AluraStore from 'components/svg/alura-store'
import AmilStorage from 'components/svg/amil-store'
import BradescoStore from 'components/svg/bradesco-store'
import MapFreStore from 'components/svg/mapfre-store'
import MetlifeStore from 'components/svg/metlife-store'
import SulAmericaStore from 'components/svg/sulamerica-store'
import UnimedStore from 'components/svg/unimed-store'
import WellHubStore from 'components/svg/wellhub-store'
import Wrapper from 'components/wrapper'
import { useStore } from 'contexts/store'
import { useState } from 'react'
import StoreCard from './card'
import StoreSelectModal from './select-modal'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))',
    gap: '1.5rem',
  },
}))

const Store = () => {
  const [open, setIsOpen] = useState<boolean>(false)
  const [product, setProduct] = useState<string | null>(null)

  const { VITE_APP_AMBIENT } = import.meta.env
  const { change, current, options } = useStore()

  const classes = useStyles()
  const isProductionEnviroment = VITE_APP_AMBIENT === 'prod' || VITE_APP_AMBIENT === 'production'

  const handleClick = (name: string) => {
    setProduct(name)
    setIsOpen(true)
  }

  if (isProductionEnviroment) {
    return (
      <Soon>
        <HeaderModule.title text='Loja' />
      </Soon>
    )
  }

  const storeItens = [
    {
      key: '1',
      logo: <WellHubStore />,
      name: 'WellHub',
    },
    {
      key: '2',
      logo: <MetlifeStore />,
      name: 'MetLife',
    },
    {
      key: '3',
      logo: <AmilStorage />,
      name: 'Amil',
    },
    {
      key: '4',
      logo: <BradescoStore />,
      name: 'Bradesco',
    },
    {
      key: '5',
      logo: <SulAmericaStore />,
      name: 'SulAmérica',
    },
    {
      key: '6',
      logo: <UnimedStore />,
      name: 'Unimed',
    },
    {
      key: '7',
      logo: <MapFreStore />,
      name: 'Mapfre',
    },
    {
      key: '8',
      logo: <AllianzStore />,
      name: 'Allianz',
    },
    {
      key: '9',
      logo: <AluraStore />,
      name: 'Alura',
    },
  ]

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title text='Loja' />
        <HeaderModule.tabs
          current={current}
          options={options}
          moduleName='store'
          onChange={change}
          disableOptions={[1, 2]}
        />
      </Header>
      <Page>
        <CustomTabPanel
          value={current}
          index={0}
        >
          <div className={classes.root}>
            {storeItens.map((item) => (
              <StoreCard
                {...item}
                onClick={() => handleClick(item.name)}
              />
            ))}
          </div>
        </CustomTabPanel>

        <StoreSelectModal
          onClose={() => setIsOpen(false)}
          open={open}
          name={product || ''}
        />
      </Page>
    </Wrapper>
  )
}

export default Store
